import { AuthorizationParams } from '@auth0/auth0-vue'
import { nullUUID } from './UUIDHelper'

export const INSTANCE_ID_KEY = 'instanceId'
export const CLIENT_ID_KEY = 'clientId'
export const RETURN_PATH_KEY = 'return_path'

/**
 * Validates a return_path value from an external URL.
 * Returns the path unchanged if valid, null if it should be rejected.
 * Rejects anything that could form a protocol-relative or absolute URL.
 */
export function validateReturnPath(path: string | null): string | null {
  if (!path) return null
  if (!path.startsWith('/')) return null
  if (path.includes('//')) return null
  if (path.includes(':')) return null
  if (path.includes('\\')) return null
  return path
}

export function isSwitchInstanceSignal(instanceId: string | null): boolean {
  return instanceId !== null && (instanceId.trim() === '' || instanceId.toLowerCase() === nullUUID)
}

export function createAuthorizationParameters(params: AuthorizationParams): AuthorizationParams {
  const instanceId = localStorage.getItem(INSTANCE_ID_KEY)
  const clientId = localStorage.getItem(CLIENT_ID_KEY)
  if (instanceId && !isSwitchInstanceSignal(instanceId)) {
    params.instance_id = instanceId
  }
  if (clientId) {
    params.skynamo_client_id = clientId
  }
  return params
}
